import useSWR from "swr";

import {
  getProvisionStock,
  listProvisionStocks,
  PROVISION_STOCKS_KEY,
} from "@/features/provision-stocks/api/provisionStocksApi";
import { toErrorMessage } from "@/lib/swr";
import type { ProvisionStockDto } from "@/types/stock.types";

const EMPTY: ProvisionStockDto[] = [];

export function useProvisionStocks() {
  const { data, error, isLoading, mutate } = useSWR(PROVISION_STOCKS_KEY, listProvisionStocks);

  return {
    stocks: data ?? EMPTY,
    isLoading,
    error: toErrorMessage(error),
    refresh: mutate,
  };
}

export function useProvisionStock(id: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR(id ? `provision-stocks/${id}` : null, () => getProvisionStock(id!));

  return {
    stock: data,
    isLoading,
    error: toErrorMessage(error),
    refresh: mutate,
  };
}
